"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const utils_1 = require("../../lib/utils");
const EducationEntry = ({ training }) => {
    if (!training) {
        return null;
    }
    const { name, type, field_of_study, degree, graduation_year } = training;
    const typeMarkup = type ? (react_1.default.createElement("span", { itemProp: "credentialCategory", key: "credentialCategory" }, type)) : null;
    const fieldOfStudyMarkup = field_of_study ? (react_1.default.createElement("span", { itemProp: "about", key: "about" }, field_of_study)) : null;
    const degreeMarkup = degree ? (react_1.default.createElement("span", { itemProp: "educationalLevel", key: "educationalLevel" }, degree)) : null;
    const graduationYearMarkup = graduation_year ? (react_1.default.createElement("span", { itemProp: "dateCreated", key: "dateCreated" }, graduation_year)) : null;
    return (react_1.default.createElement(styles_1.ExpertiseEntryContainer, { itemProp: "hasCredential", itemScope: true, itemType: "https://schema.org/EducationalOccupationalCredential" },
        react_1.default.createElement(styles_1.ExpertiseEntryHeader, { itemProp: "recognizedBy" }, name),
        react_1.default.createElement(styles_1.ExpertiseEntryCopy, null, (0, utils_1.insertBetweenItems)([
            typeMarkup,
            fieldOfStudyMarkup,
            degreeMarkup,
            graduationYearMarkup
        ].filter(Boolean), ', '))));
};
exports.default = EducationEntry;
//# sourceMappingURL=education-entry.js.map